/*
 * Liive: the LXD lens block (snippets/lxd-lens) and the X Division block
 * (snippets/xdiv-lens) in the product buy rail. Both cards carry
 * data-lxd-lens; their summary buttons are .lxd-lens__sum / .xdiv-lens__sum.
 *
 * - The summary row is a <button>: a click (or Enter / Space) toggles
 *   .is-open on the card and aria-expanded on the button.
 * - The "Lens & frame" dots follow the slider's scroll position.
 * - assets/liive-variant-refresh.js swaps the block's markup on a colour
 *   change. The open / closed choice is kept on the stable wrapper
 *   (.liive-features, data-lxd-open) and re-applied after the swap, so a
 *   shopper who opened the card keeps it open across colours.
 *
 * Delegated listeners on document, so swapped-in markup needs no rebinding.
 */
if (!window.__liiveLxdLens) {
  window.__liiveLxdLens = true;
  const SUM = '.lxd-lens__sum, .xdiv-lens__sum';

  /** @param {Element} card @param {boolean} open */
  const setOpen = (card, open) => {
    card.classList.toggle('is-open', open);
    const button = card.querySelector(SUM);
    if (button) button.setAttribute('aria-expanded', String(open));
  };

  document.addEventListener('click', (event) => {
    const target = /** @type {Element | null} */ (event.target);
    const button = target?.closest?.(SUM);
    if (!button) return;
    const card = button.closest('[data-lxd-lens]');
    if (!card) return;
    const open = !card.classList.contains('is-open');
    setOpen(card, open);
    const wrapper = card.closest('[data-liive-variant-refresh]');
    if (wrapper instanceof HTMLElement) wrapper.dataset.lxdOpen = open ? 'true' : 'false';
  });

  document.addEventListener('liive:variant-refreshed', (event) => {
    const element = /** @type {any} */ (event).detail?.element;
    if (!(element instanceof HTMLElement) || element.dataset.lxdOpen !== 'true') return;
    const card = element.querySelector('[data-lxd-lens]');
    if (card) setOpen(card, true);
  });

  document.addEventListener(
    'scroll',
    (event) => {
      const slider = event.target;
      if (!(slider instanceof HTMLElement) || !slider.classList.contains('lxd-lens__slider')) return;
      const dots = slider.closest('[data-lxd-lens]')?.querySelectorAll('.lxd-lens__dots i');
      if (!dots || !dots.length) return;
      const max = slider.scrollWidth - slider.clientWidth;
      const at = max > 0 ? Math.round((slider.scrollLeft / max) * (dots.length - 1)) : 0;
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === at));
    },
    true,
  );
}
